



$(document).ready(function () {

    let checkIframeLoaded = function(iframeElement) {
        var iframe = iframeElement[0];
        var iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

        if (  iframeDoc.readyState  === 'complete' ) {
            iframe.contentWindow.onload = function(){
                alert("Laden fertig");
            };
            afterLoading();
            return;
        }

        window.setTimeout(checkIframeLoaded, 100);
    }

    let afterLoading = function() {
        $('.mosaic-loader').fadeOut();
    }

    if ($('.widgetintegration').length) {
        $('.widgetintegration').find('iframe').each(function() {
            checkIframeLoaded($(this));
        });
    }
});
